import React from 'react';
import { IBaseActionButtonProps } from '../interfaces';
import BaseActionButton from '../BaseActionButton';
import useStyles from './styles';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/deleteIcon.svg';

const DeleteActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <DeleteIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default DeleteActionButton;
